import React, { useState, useEffect, useMemo } from 'react';
import Img from 'gatsby-image';
import ReactPlayer from 'react-player';
import { StyledVideoEmbed, StyledVideo, StyledPoster } from './styles';
import PlayButtonSVG from '../../assets/svg/icons/play-button.svg';

const VideoEmbed = ({ videoUrl, poster, ...props }) => {
  const [isReady, setReady] = useState(false);
  const [isStarted, setStarted] = useState(Boolean(props.playing));

  const src = useMemo(() => {
    if (videoUrl.includes('vimeo') && !videoUrl.includes('player.vimeo')) {
      return videoUrl.replace('vimeo.com/', 'player.vimeo.com/video/');
    }
    if (videoUrl.includes('watch?v=')) {
      return videoUrl.replace('watch?v=', 'embed/');
    }
    return videoUrl;
  }, [videoUrl]);

  useEffect(() => {
    setReady(false);
  }, [src]);

  const onReady = () => {
    setTimeout(() => setReady(true), 50);
  };

  const onStart = () => {
    setStarted(true);
  };

  return (
    <StyledVideoEmbed
      isReady={isReady}
      showVideo={!poster || (poster && isStarted)}
      showPoster={poster && !isStarted}
    >
      {!isStarted && poster && (
        <StyledPoster role="button" onClick={() => setStarted(true)}>
          <div className="play-btn">
            <PlayButtonSVG />
          </div>
          <Img
            sizes={{
              ...poster.imageFile.childImageSharp.fluid,
              aspectRatio: 16 / 9,
            }}
          />
        </StyledPoster>
      )}

      <StyledVideo>
        <ReactPlayer
          key={videoUrl}
          className="react-player"
          title="Product Tour Video"
          url={src}
          playing={isStarted}
          width="100%"
          height="100%"
          onReady={onReady}
          onStart={onStart}
          {...props}
        />
      </StyledVideo>
    </StyledVideoEmbed>
  );
};
export default VideoEmbed;
